var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[(_vm.flag)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',[_c('img',{staticClass:"kong",attrs:{"src":require("../assets/imgs/kong.png"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v("暂无内容")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }